import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { createClinicianUserInitQuery, Location } from './queries';
import { useQuery } from '@apollo/client';
import { CreateClinicianUsersComponent } from '../../../../../components/Global';

type UrlParams = {
  location_id: string;
};

const CreateClinicianUsers = (): React.ReactElement => {
  const navigate = useNavigate();

  const { location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    organisation: {
      name: '',
    },
  });

  const { data: createClinicianUserInitData } = useQuery(createClinicianUserInitQuery(location_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (createClinicianUserInitData) {
      setLocation(createClinicianUserInitData.locations_by_pk);
    }
  }, [createClinicianUserInitData]);

  const handleFinish = (userId: string) => {
    navigate(`/org/locations/${location_id}/clinicians/${userId}`);
  };

  return (
    <DashboardLayout
      breadcrumbs={[
        { label: 'Home', link: '/org/home' },
        { label: 'Hospitals', link: `/org/locations` },
        { label: location.name, link: `/org/locations/${location_id}` },
        { label: 'Clinicians', link: `/org/locations/${location_id}/clinicians` },
        { label: 'Create' },
      ]}>
      <CreateClinicianUsersComponent locationId={location_id!} handleFinish={handleFinish} />
    </DashboardLayout>
  );
};

export default CreateClinicianUsers;
